import { render, staticRenderFns } from "./MobileFooterLinks.vue?vue&type=template&id=6183afb0"
import script from "./MobileFooterLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileFooterLinks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MobileFooterLinks.vue?vue&type=style&index=0&id=6183afb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports